<script lang="ts" setup>
import { computed, PropType } from 'vue'

import { formatToTitleOfProduct } from '@/utils/formatToTitleOfProduct'

import { ConstructorPizza } from '@/types/api/api-v3/halves'

const props = defineProps({
  constructorPizza: {
    type: Object as PropType<ConstructorPizza>,
    required: true,
  },
})

const isTitleConstructor = computed(() => {
  const { leftHalve, rightHalve } = props.constructorPizza

  return {
    leftHalveName: leftHalve
      ? formatToTitleOfProduct(leftHalve)
      : 'левая половинка',
    rightHalveName: rightHalve
      ? formatToTitleOfProduct(rightHalve)
      : 'правая половинка',
  }
})
</script>

<template>
  <div class="state-bar__title-line">
    <span
      class="state-bar__title"
      :class="{
        'state-bar__title--empty': !constructorPizza.leftHalve,
      }"
    >
      {{ `${isTitleConstructor.leftHalveName}` }}
    </span>
    <span
      v-if="
        isTitleConstructor.leftHalveName !== isTitleConstructor.rightHalveName
      "
      class="state-bar__title"
      :class="{
        'state-bar__title--empty': !constructorPizza.rightHalve,
      }"
    >
      {{ ` + ${isTitleConstructor.rightHalveName}` }}
    </span>
  </div>
</template>

<style lang="scss" scoped>
.state-bar {
  &__title-line {
    margin-bottom: 20px;
    font-size: 24px;
    font-weight: 800;
    line-height: 32px;

    @include media('<=desktop-mini') {
      margin: 0 20px 0 0;
      font-size: 16px;
      font-weight: 800;
      line-height: 14px;
    }

    @include media('<=tablet') {
      font-size: 12px;
    }
  }

  &__title {
    font-weight: 800;

    &--empty {
      font-weight: 500;
      color: var(--ui-unactive-gray);
      text-transform: lowercase;
    }

    @include media('<=desktop-mini') {
      font-size: 16px;
      font-weight: 800;
      line-height: 14px;

      &--empty {
        font-weight: 500;
      }
    }

    @include media('<=tablet') {
      font-size: 12px;
    }
  }

  &__symbol {
    font-size: 24px;
    font-weight: 800;
    line-height: 32px;
    color: var(--ui-text-secondary);
  }
}
</style>
